import { useQuery } from "@apollo/client";
import { GridInputs } from "../../../../../components/Functional";
import { FETCH_FABRICATION_TYPES } from "../../../../../graphql/query/FabricationType";

const Costs = props => {
  const { formik } = props;
  const { data: { fabricationTypes = [] } = {} } = useQuery(
    FETCH_FABRICATION_TYPES,
  );

  const inputs = {
    className: "grid grid-cols-1 gap-4 lg:grid-cols-4 lg:gap-16",
    inputs: [
      {
        className: "grid grid-rows-2 gap-4",
        inputs: [
          {
            label: "Type",
            name: "_fabrication.typeId",
            type: "multi-select",
            options: fabricationTypes
              ?.filter(item => item?.category === 2)
              .map(item => ({
                label: item?.description,
                value: item?.id,
              })),
          },
        ],
      },
    ],
  };

  const gridInputProps = {
    formik,
    ...inputs,
  };

  return <GridInputs {...gridInputProps} />;
};

export default Costs;
